import React from "react";

import SuggestedVideo from "./SuggestedVideo";
import Spinner from "../UI/Spinner";
import ActualComment from "./ActualComment";
import SubscribeBtn from "./SubscribeBtn";
import classes from "./Watch.module.css";
import { connect } from "react-redux";
import numeral from "numeral";
import he from "he";
import {
  getChannelInfo,
  getSuggestedVideo,
  getComments,
  getVideo,
  gotVideo
} from "../../Actions/index";

class Watch extends React.Component {
  constructor(props) {
    super(props);

    // storing videoId
    if (this.props.location.videoId && this.props.location.channelId) {
      sessionStorage.setItem("videoId", this.props.location.videoId);
      sessionStorage.setItem("channelId", this.props.location.channelId);
    } else if (!sessionStorage.getItem("videoId")) return;

    this.state = {
      show: false,
      videoId: sessionStorage.getItem("videoId"),
      channelId: sessionStorage.getItem("channelId"),
      fromSuggested: false
    };
    this.setCurrentVideo();
  }
  setCurrentVideo() {
    // if there is no location.videoId && location.channelId then call getVideo && channelInfo
    if (
      (!this.props.location.videoId &&
        !this.props.location.channelId &&
        sessionStorage.getItem("videoId")) ||
      this.state.fromSuggested
    ) {
      this.props.getVideo(this.state.videoId);
      this.props.getChannelInfo(this.state.channelId);
      this.props.getComments(this.state.videoId);
    } else {
      // if there is locaiton.videoId and .channelId, then
      const videoId = this.state.videoId;
      let video;
      if (this.props.location.fromHome === true) {
        const data = this.props.home.data;
        for (let keys in data) {
          let found = false;
          const item = data[keys].data;
          for (let i = 0; i < item.length; i++) {
            if (videoId === item[i].id) {
              video = { ...item[i] };
              found = true;
              break;
            }
          }
          if (found) break;
        }
      } else if (this.props.location.fromHome === false) {
        const items = this.props.searchResults.results.items;
        for (let i = 0; i < items.length; i++) {
          if (videoId === items[i].id.videoId) {
            video = { ...items[i] };
            break;
          }
        }
      }
      this.props.gotVideo(video);
    }
  }

  videoFromSuggested = async (videoId, channelId) => {
    await this.setState({ videoId, channelId, fromSuggested: true });
    sessionStorage.setItem("videoId", videoId);
    sessionStorage.setItem("channelId", channelId);
    this.setCurrentVideo();
    window.scroll(0, 0);
  };

  fillingData(params) {
    this.props.getSuggestedVideo(this.state.videoId, params);
  }

  hasReachedEnd() {
    const el = document.querySelector("html");
    const video = document.querySelector(`.${classes.Videos} >*:last-child`);

    const cmtToken = this.props.comments.results.nextPageToken;
    const videoToken = this.props.suggestedVideos.results.nextPageToken;

    const callComments = (next = "") => {
      this.props.getComments(this.state.videoId, next);
    };
    // if both of these are not true Or nothing is loading
    if (
      !this.props.comments.loading &&
      !this.props.suggestedVideos.loading &&
      video
    ) {
      if (
        window.innerWidth < 1020 &&
        el.scrollHeight - el.scrollTop === el.clientHeight
      ) {
        if (this.props.suggestedVideos.pageNum < 2)
          this.fillingData(`&pageToken=${videoToken}`);
        else if (this.props.comments.pageNum === 0) callComments();
        else callComments(`&pageToken=${cmtToken}`);
      } else {
        if (
          window.innerHeight + el.scrollTop >= video.offsetTop &&
          this.props.suggestedVideos.pageNum < 2
        ) {
          this.fillingData(`&pageToken=${videoToken}`);
        } else if (
          el.scrollHeight - el.scrollTop === el.clientHeight &&
          this.props.comments.pageNum > 0
        ) {
          callComments(`&pageToken=${cmtToken}`);
        }
      }
    }
    // Mobile First, if user has reached the end get more suggested videos.
    // If you have 2 sec of more suggested videos then keep getting comments.

    // Desktop if the user has scroll like 500px; get the comments
    // if the user has scroll to the end of suggested videos, get more.
    // if te user has scroll to the bottom of the page keep getting more comments.
  }
  componentDidMount() {
    if (!sessionStorage.getItem("videoId") && !this.state.videoId) return;
    let el = document.querySelector("main");
    if (el) el.style.gridColumn = "1/3";
    window.addEventListener("scroll", this.hasReachedEnd.bind(this));
    if (this.props.comments.pageNum === 0 && !this.props.comments.loading)
      this.props.getComments(this.state.videoId);
    if (this.state.channelId) this.props.getChannelInfo(this.state.channelId);
    if (this.state.videoId) this.fillingData();
    window.scroll(0, 0);
  }
  getSuggestedVideos() {
    if (!this.props.suggestedVideos.results.items) return [];
    const videos = this.props.suggestedVideos.results.items.map((video, i) => {
      if (!video.statistics) video.statistics = { viewCount: 0 };
      if (!video.contentDetails) video.contentDetails = { duration: "00:00" };
      return (
        <SuggestedVideo
          title={video.snippet.title}
          viewsCount={video.statistics.viewCount}
          channelName={video.snippet.channelTitle}
          key={i}
          videoId={video.id.videoId}
          channelId={video.snippet.channelId}
          imgSrc={video.snippet.thumbnails.medium.url}
          duration={video.contentDetails.duration}
          videoFromSuggested={this.videoFromSuggested}
        />
      );
    });
    return videos;
  }
  getComments() {
    if (!this.props.comments.results.items) return [];
    const comments = this.props.comments.results.items.map((cmt, i) => {
      const snip = cmt.snippet.topLevelComment.snippet;
      if (!cmt.replies) cmt.replies = { comments: [] };
      return (
        <ActualComment
          replies={cmt.replies.comments}
          name={snip.authorDisplayName}
          imgSrc={snip.authorProfileImageUrl}
          content={snip.textOriginal}
          likes={snip.likeCount}
          date={snip.publishedAt}
          key={i}
        />
      );
    });
    return comments;
  }
  componentWillUnmount() {
    document.querySelector("main").style.gridColumn = "";
    window.removeEventListener("scroll", this.hasReachedEnd);
  }

  render() {
    if (!sessionStorage.getItem("videoId") && !this.state.videoId) {
      this.props.history.push("/");
      return null;
    }

    const snip = this.props.currVidSnip;
    const stat = this.props.currVidStat;
    if (!stat && !snip) return null;
    const cmtCnt = stat.commentCount;
    let comment;
    if (cmtCnt === 0) comment = "No Comments";
    else
      comment = `${numeral(cmtCnt).format()} Comment${cmtCnt > 1 ? "s" : ""}`;
    const ratio = (
      (parseInt(stat.likeCount) /
        (parseInt(stat.likeCount) + parseInt(stat.dislikeCount))) *
      100
    ).toFixed(2);
    let likePer = 100;
    let dislikePer = 0;
    if (ratio >= 50) dislikePer = (ratio - 50) * 2;
    else likePer = ratio * 2;
    const publishedOn = new Date(
      snip.publishedAt.substr(0, 10).replace(/-/g, " ")
    )
      .toString()
      .substr(4, 11)
      .replace(/([0-9])\s/, "$1, ");

    return (
      <section className={classes.Watch}>
        <div className={classes.Video}>
          <div className={classes.Player}>
            <iframe
              src={`https://www.youtube.com/embed/${
                this.state.videoId
              }?autoplay=1`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="kl"
            />
          </div>
          <div className={classes.MetaData}>
            <h2>{he.decode(snip.title)}</h2>
            <div className={classes.BasicData}>
              <div>{numeral(stat.viewCount).format()} views</div>
              <div className={classes.Actions}>
                <div>
                  <i className="fas fa-thumbs-up" />
                  <span>{numeral(stat.likeCount).format("0.a")}</span>
                  <div
                    className={classes.LikeCount}
                    style={{ width: `${likePer}%` }}
                  />
                </div>
                <div>
                  <i className="fas fa-thumbs-down" />
                  <span>{numeral(stat.dislikeCount).format("0.a")}</span>
                  <div
                    className={classes.DislikeCount}
                    style={{ width: `${dislikePer}%` }}
                  />
                </div>
                <div>
                  <i className="fas fa-share" />
                  <span>SHARE</span>
                </div>
                <div>
                  <i className="fas fa-list-alt" />
                  <span>SAVE</span>
                </div>
                <div>
                  <i className="fas fa-ellipsis-h" />
                </div>
              </div>
            </div>
            <div className={classes.VideoInfo}>
              <div className={classes.ChannelPic}>
                <img
                  src={this.props.channelInfo.profilePic}
                  alt="channel pic"
                />
              </div>
              <div className={classes.VideoDetails}>
                <div className={classes.ChannelInfo}>
                  <div>
                    <div className={classes.ChannelName}>
                      {snip.channelTitle}
                    </div>
                    <div>Published on {publishedOn}</div>
                  </div>
                  <SubscribeBtn
                    subscribers={this.props.channelInfo.subscribers}
                  />
                </div>
                <div>
                  <div
                    className={classes.VideoDescription}
                    style={{ height: this.state.show ? "auto" : "80px" }}
                  >
                    <pre>{snip.detailDescription}</pre>
                    <div className={classes.VideoType}>
                      <span>Category</span>
                      <span>Entertainment</span>
                    </div>
                  </div>
                  <button
                    className={classes.ToggleDescription}
                    onClick={() =>
                      this.setState(preState => ({ show: !preState.show }))
                    }
                  >
                    SHOW {this.state.show ? "LESS" : "MORE"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.Videos}>
          {this.getSuggestedVideos()}
          {this.props.suggestedVideos.loading ? (
            <Spinner isMini={true} />
          ) : null}
        </div>
        <div className={classes.Comments}>
          <div className={classes.CommentsInfo}>
            <div>{comment}</div>
            <div className={classes.CommentsBtns}>
              <svg viewBox="0 0 24 24" focusable="false">
                <g>
                  <path d="M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z" />
                  <path d="M0 0h24v24H0z" fill="none" />
                </g>
              </svg>
              <div>SORT BY</div>
            </div>
          </div>
          <div className={classes.NewComment}>
            <div className={classes.UserDefaultPic}>
              <img
                src="http://s.ytimg.com/yts/img/avatar_48-vfllY0UTT.png"
                alt="profile pic"
              />
            </div>
            <div className={classes.WriteComment}>Add a public comment...</div>
          </div>
          {this.getComments()}
          {this.props.comments.loading ? <Spinner isMini={true} /> : null}
        </div>
      </section>
    );
  }
}
const mapStateToProps = state => {
  return {
    currVidId: state.currentVideo.id,
    currVidSnip: state.currentVideo.snippet,
    currVidStat: state.currentVideo.statistics,
    channelInfo: state.channelInfo,
    suggestedVideos: state.suggestedVideos,
    home: state.home,
    searchResults: state.searchResults,
    comments: state.comments
  };
};
export default connect(
  mapStateToProps,
  {
    getChannelInfo,
    getSuggestedVideo,
    getComments,
    getVideo,
    gotVideo
  }
)(Watch);
